export default __webpack_public_path__ + "static/media/training-illustration12.01b9cfc1.png";